import React from "react";
import styled from "styled-components";

import Header from "./components/header";
import { Services } from "./components/servicios";
import { AboutUs } from "./components/AboutUs";
import { Sedes } from "./components/Sedes";
import { SectionNews } from "./components/Layout/SectionNews";
import HeaderMobile from "./components/headerMobile";
import useThemes from "./hooks/useThemes";
import { SectionButtons } from "./components/Layout/SectionButtons";

export const Client = () => {
  const { backgroundQuinto } = useThemes();

  return (
    <Container background={backgroundQuinto}>
      <Header />
      <HeaderMobile />
      <Services />
      <AboutUs />
      <SectionNews />

      {/* BOTONES NUEVOS */}
      <SectionButtons />

      <Sedes titleSedes="Sedes de atención" />
    </Container>
  );
};

const Container = styled.div`
  position: relative;
  background-color: ${(props) => props.background};
`;
